import axiosIns from '@/libs/axios'

export default {
  namespaced: true,
  actions: {
    async fetchGroups(_, params) {
      const res = (
        await axiosIns.get('/groups', {
          params,
        })
      ).data.data.data
      return res
    },
    getGroup(_, groupId) {
      return axiosIns.get(`groups/${groupId}`)
    },
    deleteGroup(_, groupId) {
      return axiosIns.delete(`groups/${groupId}`)
    },
    createGroup(_, newGroup) {
      return axiosIns.put('/groups', newGroup)
    },
    getGroupUsers(_, { groupID, page, perPage }) {
      return axiosIns.get(`groups/${groupID}/users`, {
        params: {
          page,
          perPage,
        },
      })
    },
    addUsersToGroup(_, { groupID, phoneNumbers }) {
      return axiosIns.post(`groups/${groupID}/users`, {
        users: phoneNumbers,
      })
    },
    removeUserFromGroup(_, { groupID, body }) {
      return axiosIns.post(`groups/${groupID}/users/delete`, body)
    },
    getGroupSheetSignedUrl(_, fileName) {
      return axiosIns.get('signed-urls/groupSheet', {
        params: {
          fileName,
        },
      })
    },
    importUsersToGroup(_, { groupID, s3Key }) {
      return axiosIns.post(`groups/${groupID}/import-users`, {
        sheetUrl: s3Key,
      })
    },
    sendNotificationToGroup(_, { groupID, data }) {
      return axiosIns.post(`groups/${groupID}/group-notification`, data)
    },
    updateGroup(_, { groupId, data }) {
      return axiosIns.patch(`groups/${groupId}`, data)
    },
  },
}
